module.exports = __webpack_public_path__ + "img/boxgifnew.fdeeeea9.gif";